export default __webpack_public_path__ + "static/media/SS.0f0a363e.svg";